<template>
  <div
    class="w-full h-12 bg-white hidden lg:flex justify-between items-center text-contrast-light border-b"
  >
    <div class="pl-4">
      <RouterLink to="/">
        <img
          class="h-10 w-10"
          alt="Logo Projekt CH+"
          src="@/assets/logo/logo-chplus-color.svg"
        />
      </RouterLink>
    </div>
    <div class="flex gap-8" style="margin-right: 2.5rem;">
      <RouterLink to="/election">
        <div class="flex h-full items-center gap-1">
          <img
            v-if="$route.path === '/election'"
            class="h-6 w-6"
            src="@/assets/icons/menu-bottom-icon-double-circles.svg"
          />
          <img
            v-else
            class="h-6 w-6"
            src="@/assets/icons/menu-bottom-icon-double-circles-outline.svg"
          />
          <p class="text-chplus-l">{{ $t("views.home.selection") }}</p>
        </div>
      </RouterLink>
      <RouterLink to="/government">
        <div class="flex h-full items-center gap-1">
          <img
            v-if="$route.path === '/government'"
            class="h-6 w-6"
            src="@/assets/icons/menu-bottom-icon-polygon.svg"
          />
          <img
            v-else
            class="h-6 w-6"
            src="@/assets/icons/menu-bottom-icon-polygon-outline.svg"
          />

          <p class="text-chplus-l">{{ $t("views.home.government") }}</p>
        </div>
      </RouterLink>
    </div>
  </div>
</template>

<script>
export default {
  name: "LargeDisplayNavbar"
};
</script>
